import { Component, Input, OnInit } from '@angular/core';
import { StatusDisplayType } from './status-display.types';
import { upperFirst } from 'lodash';
import { IcaAnalysisStatus, IcaStepStatus } from '@models/appSessions/appSession';

@Component({
  selector: 'app-status-display',
  templateUrl: './status-display.component.html',
  styleUrls: ['./status-display.component.scss']
})
export class StatusDisplayComponent implements OnInit {

  // For template expression to access enum
  public readonly StatusDisplayType = StatusDisplayType;

  private readonly STATUS_MAPPING = {
    [IcaStepStatus.DONE.toUpperCase()]: StatusDisplayType.SUCCESS,
    [IcaStepStatus.FAILED.toUpperCase()]: StatusDisplayType.ERROR,
    [IcaStepStatus.ABORTED.toUpperCase()]: StatusDisplayType.ERROR,
    [IcaAnalysisStatus.SUCCEEDED.toUpperCase()]: StatusDisplayType.SUCCESS,
    [IcaAnalysisStatus.FAILED.toUpperCase()]: StatusDisplayType.ERROR,
    [IcaAnalysisStatus.FAILED_FINAL.toUpperCase()]: StatusDisplayType.ERROR,
    [IcaAnalysisStatus.ABORTED.toUpperCase()]: StatusDisplayType.ERROR,
    // If no mapping, default to StatusDisplayType.INFO
  };

  private readonly ICON_MAPPING = {
    [StatusDisplayType.SUCCESS]: 'checkmark',
    [StatusDisplayType.ERROR]: 'exclamationTriangle',
    [StatusDisplayType.INFO]: 'info',
  };

  @Input() statusValue: string = '';

  displayType = StatusDisplayType.INFO;
  displayValue = '-';
  iconName = '';

  constructor() { }

  ngOnInit() {
    this.displayType = this.mapDisplayType(this.statusValue);
    this.displayValue = this.prettifyDisplayValue(this.statusValue);
    this.iconName = this.ICON_MAPPING[this.displayType] || 'info';
  }

  private mapDisplayType(val: string): StatusDisplayType {
    if (val.toUpperCase() in this.STATUS_MAPPING) {
      return this.STATUS_MAPPING[val.toUpperCase()];
    }
    return StatusDisplayType.INFO;
  }

  private prettifyDisplayValue(val: string) {
    return upperFirst(val.toLowerCase());
  }

}
